const Loader = ({ type }) => {
  return type == "head-coin" ? (
    <img
      id="coinVideo"
      className="ng-tns-c4049933992-86 ng-star-inserted heartBeat"
      src={"/assets/Other/logo.png"}
    />
  ) : (
    <>
      <div className="loading-mask ng-tns-c978432208-1 ng-trigger ng-trigger-fastFadeInOut ng-star-inserted" />
      <div className="loader-box ng-tns-c978432208-1 ng-star-inserted">
        <div className="movie-box ng-tns-c978432208-1 ng-star-inserted">
         <img
            style={{ width: "100%" }}
            id="coinVideo"
            className="ng-tns-c4049933992-86 ng-star-inserted"
            src={"/assets/Other/logo.png"}
          />
        </div>
      </div>{" "}
    </>
  );
};

export default Loader;

{
  /* <app-loader-box
  _ngcontent-serverapp-c3783694019=""
  _nghost-serverapp-c3786824599=""
  class="ng-tns-c3786824599-1 ng-tns-c3783694019-0 ng-star-inserted">
  <div
    _ngcontent-serverapp-c3786824599=""
    className="loading-mask ng-tns-c3786824599-1 ng-trigger ng-trigger-fastFadeInOut ng-star-inserted"
  />
  <div
    _ngcontent-serverapp-c3786824599=""
    className="loader-box ng-tns-c3786824599-1 ng-star-inserted">
    <div
      _ngcontent-serverapp-c3786824599=""
      className="movie-box ng-tns-c3786824599-1">
      <img
        _ngcontent-serverapp-c3786824599=""
        alt="loader"
        className="ng-tns-c3786824599-1"
        height="100%"
        loading="lazy"
        src="https://img.e491328.com/e28/h5/assets/images/animation/loader.webp?v=1762247150189"
        width="100%"
      />
    </div>
  </div>
</app-loader-box> */
}
